import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Icon } from 'react-spark';

class NovaModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        id: PropTypes.string.isRequired,
        children: PropTypes.node,
        ariaLabelledby: PropTypes.string,
        ariaDescribedby: PropTypes.string,
        size: PropTypes.string,
        type: PropTypes.string
    };

    static defaultProps = {
        type: 'info',
        size: 'large'
    };

    render() {
        const {
            show,
            onClose,
            title,
            subtitle,
            id,
            children,
            ariaLabelledby,
            ariaDescribedby,
            size,
            type,
            ...otherProps
        } = this.props;

        return (
            <Modal
                show={show}
                onClose={onClose}
                title={title}
                id={id}
                type={type}
                size={size}
                ariaLabelledby={ariaLabelledby}
                ariaDescribedby={ariaDescribedby}
                hasCloseButton={false} // Nova custom close button by default false
                {...otherProps}
            >
                {/* Custom close button */}
                <button
                    className="nova-modal-close-button"
                    type="button"
                    aria-label="Close Modal"
                    onClick={onClose}
                >
                    <Icon name='close' style={{ height: 36, width: 36, strokeWidth: 2 }} color='base' />
                </button>
                
                {subtitle && (
                    <div className="nova-modal-subtitle">
                        {subtitle}
                    </div>
                )}
                
                {children}
            </Modal>
        );
    }
}

export default NovaModal;
